import { SxProps, Theme } from '@mui/material';

export const fullPageReportStyles = {
  root: (theme: Theme) => ({
    width: '100%',
  }) as SxProps<Theme>,

  content: (theme: Theme) => ({
    width: '100%',
  }) as SxProps<Theme>,
};

export default fullPageReportStyles;
